module.exports = __webpack_public_path__ + "static/image/history/pc/201707.ver2_0_2.jpg?b039b5f6";